"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherSupplySchema = void 0;
const yup = __importStar(require("yup"));
const os = __importStar(require("../attributes/otherSupplyAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.OtherSupplySchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes['Other Supply']),
    otherSupplyType: shared.titleSetLargeSchema.required(),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(os.SellingUnit)),
    name: shared.titleSetLargeSchema.optional(),
    widthCM: shared.widthCMSchema.optional(),
    lengthCM: shared.widthLengthBaseSchema.min(1).max(250).optional(),
    lengthM: shared.widthLengthBaseSchema.max(200).optional(),
    otherSupplyLengthType: utils_1.reqSelectOneSchema(Object.values(os.KnownOrEstimated)),
    heightCM: shared.widthLengthBaseSchema,
    weightG: shared.widthLengthBaseSchema.required(),
    weightLB: shared.widthLengthBaseSchema.required(),
    weight: utils_1.optSelectOneSchema(Object.values(os.Weight)),
    osSize: utils_1.optSelectOneSchema(Object.values(os.osSize)),
    bulky: yup.boolean().default(false),
    quantity: shared.quantitySchema.required(),
    packSize: yup
        .number()
        .transform(utils_1.NaNtoUndefined)
        .integer()
        .positive()
        .min(1)
        .required(),
    packSizeType: utils_1.reqSelectOneSchema(Object.values(os.KnownOrEstimated)),
    dimensionDescription: utils_1.reqSelectOneSchema(Object.values(os.DimensionDescription)),
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    additionalInfo: shared.sentenceSetSchema.optional(),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    price: shared.priceSchema
})
    .test('Ensure widthCM is required for by meter', (value, context) => {
    var _a, _b;
    const errorMsg = context.createError({
        path: 'widthCM',
        message: 'Width (cm) is required for by meter selling unit'
    });
    const isByMeter = (_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product.sellingUnit;
    const widthCM = (_b = context.options.context) === null || _b === void 0 ? void 0 : _b.product.widthCM;
    if (value &&
        isByMeter === os.SellingUnit['By Meter'] &&
        (!widthCM || widthCM <= 0)) {
        return errorMsg;
    }
    else {
        return true;
    }
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case os.SellingUnit['By Meter']:
            return schema.omit([
                'packSize',
                'lengthCM',
                'dimensionDescription',
                'weightLB',
                'heightCM',
                'quantity',
                'osSize',
                'packSizeType'
            ]);
        case os.SellingUnit.Individual:
            return schema.omit([
                'packSize',
                'lengthM',
                'dimensionDescription',
                'weightLB',
                'packSizeType',
                'otherSupplyLengthType'
            ]);
        case os.SellingUnit['By Weight']:
            return schema.omit([
                'packSize',
                'lengthM',
                'osSize',
                'packSizeType',
                'otherSupplyLengthType',
                'weightG'
            ]);
        case os.SellingUnit.Pack:
            return schema.omit([
                'lengthM',
                'dimensionDescription',
                'weightLB',
                'otherSupplyLengthType'
            ]);
    }
})
    .test('Context Check', "Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=otherSupplySchema.js.map